module.exports = __webpack_public_path__ + "static/media/ampl.d0cda431.svg";